import data from "./usa-states-dimensions.json";

export default data;
